/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useContext, useEffect, useRef, useState } from "react";
import { Button, Container, Row } from "react-bootstrap";
import { CImage } from "@coreui/react";
import { BsCaretDownFill, BsFillTrashFill, BsGeoAltFill } from "react-icons/bs";
import Swal from "sweetalert2";
import { StoreContext } from "../context/StoreContext";
import { useBucket } from "../context/GetBucketDetailsContext";
import authservice from "../services/auth.services";
import { useStoreStock } from "../context/StoreStockContext";

const Header = (props) => {
  const dropdownRef = useRef(null);
  const city = localStorage.getItem("selectedCity");
  const [updatingItems, setUpdatingItems] = useState({});
  const [bucketDropdownOpen, setBucketDropdownOpen] = useState(false);
  const [categoryDropdownOpen, setCategoryDropdownOpen] = useState(false);
  const {
    storeTypes,
    sidebarIcons,
    selectedStore,
    setSelectedStore,
    setSelectedSortOption,
    setDropdownOpen,
    setHasSearched,
    setShowSelect,
    manuallyToggled,
    setManuallyToggled,
    setSelectedStoreID,
    setPageNo,
  } = useContext(StoreContext);
  const {
    bucketItems,
    bucketCount,
    loading: bucketLoading,
    removeBucketItem,
    clearBucket,
  } = useBucket();
  const {
    getStoresDetails,
    setSortByPrice,
    setSortByDistance,
    setIsAvailable,
    setShowStoreStock,
    setViewMoreState,
  } = useStoreStock();

  const getUserKeyAndStore = async () => {
    const url = "getUserKey";
    try {
      const response = await authservice.postJsonData(url);
      if (response.apiResponseCode === "1001" && response.userKey) {
        localStorage.setItem("userKey", response.userKey);
      } else {
        console.warn("Failed to get userKey:", response.apiResponseMsg);
      }
    } catch (error) {
      console.error("Error fetching userKey:", error);
    }
  };

  const handleIconClick = () => {
    setShowSelect((prev) => !prev);
    setManuallyToggled(true);
  };

  const handleRemoveItem = async (item) => {
    const itemKey = `${item.bucketID}-${item.productVariationID}`;
    setUpdatingItems((prev) => ({ ...prev, [itemKey]: true }));
    try {
      await removeBucketItem(item.bucketID);
    } catch (error) {
      console.error("Error removing item:", error);
    } finally {
      setUpdatingItems((prev) => ({ ...prev, [itemKey]: false }));
    }
  };

  const clearAllBucket = async () => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This will clear all items from your basket!",
      imageUrl: "/images/clear-cart.svg",
      imageWidth: 200,
      imageHeight: 200,
      customClass: {
        popup: "swal-z-top",
      },
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, clear it!",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      try {
        const response = await clearBucket();

        if (response?.apiResponseCode === "1001") {
          setBucketDropdownOpen(false);
          setShowStoreStock(false);
          setHasSearched(false);
        }
      } catch (error) {
        console.warn("Error clearing basket:", error);
        Swal.fire("Error", "Failed to clear the basket.", "error");
      }
    }
  };

  const clickSearchAll = async () => {
    setSortByPrice("");
    setSortByDistance("");
    setIsAvailable("");
    setViewMoreState({});
    await getStoresDetails();
  };

  useEffect(() => {
    const handleResize = () => {
      if (!manuallyToggled) {
        setShowSelect(window.innerWidth > 805);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [manuallyToggled]);

  useEffect(() => {
    const userKey = localStorage.getItem("userKey");
    if (!userKey) {
      getUserKeyAndStore();
    }
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setCategoryDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  useEffect(() => {
    if (bucketCount === 0 && bucketItems?.length === 0) {
      setHasSearched(false);
    }
  }, [bucketCount, bucketItems]);

  return (
    <Container fluid>
      <Row>
        <div className="ezybuy-header">
          <div className="left-side--wrap">
            <span className="logo-site">
              <CImage
                src="/images/logo.png"
                alt="brand-name"
                className="logo full-image"
                width={100}
                height={60}
              />
              <span className="tagline"> The Neighborhood Search Engine</span>
            </span>

            <span className="ezy-search-icon" onClick={handleIconClick}>
              <img
                src="../images/search-icon.svg"
                className="search-mb-icon"
                alt="search-icon"
                style={{ width: "17px" }}
              />
            </span>

            {/* categories dropdown */}
            <div
              className="relative inline-block text-left font-inter select-mobile-hide"
              ref={dropdownRef}
            >
              {/* Dropdown Toggle Button */}
              <button
                type="button"
                className="sorting-dropdown categories-dropdown"
                onClick={() => setCategoryDropdownOpen(!categoryDropdownOpen)}
                aria-haspopup="true"
                aria-expanded={categoryDropdownOpen ? "true" : "false"}
              >
                <span>{selectedStore?.name}</span>
                <BsCaretDownFill />
              </button>

              {/* Dropdown Menu */}
              {categoryDropdownOpen && (
                <div
                  className="sorting-dropdown-menu categories-dropdown"
                  role="menu"
                  aria-orientation="vertical"
                  aria-labelledby="menu-button"
                >
                  <div role="none" className="sorting-dropdown-options">
                    {/* All Categories */}
                    <label
                      className={`dropdown-items sorting-dropdown-options-label ${
                        selectedStore?.name === "All Stores" ? "active" : ""
                      }`}
                      onClick={() => {
                        setSelectedStore({
                          name: "All Stores",
                          storeTypeID: "",
                        });
                        setPageNo(1);
                        setSelectedStoreID(null);
                        setCategoryDropdownOpen(false);
                        setSelectedSortOption({});
                        setDropdownOpen(false);
                        setShowStoreStock(false);
                        setHasSearched(false);
                      }}
                      role="link"
                      tabIndex={0}
                      onKeyDown={(e) => e.preventDefault()}
                    >
                      <div className="option-all">All</div>
                      All Stores
                    </label>
                    {/* Dynamic Store Types */}
                    {storeTypes?.map((el, index) => (
                      <label
                        key={el?.storeTypeID}
                        className={`dropdown-items sorting-dropdown-options-label ${
                          selectedStore?.name === el?.name ? "active" : ""
                        }`}
                        onClick={() => {
                          setSelectedStore({
                            name: el?.name,
                            storeTypeID: el?.storeTypeID,
                          });
                          setCategoryDropdownOpen(false);
                          setSelectedSortOption({});
                          setDropdownOpen(false);
                          setShowStoreStock(false);
                          setHasSearched(false);
                        }}
                      >
                        <div>
                          <CImage
                            className={`sidebar-icon ${
                              selectedStore?.name === el?.name ? "active" : ""
                            }`}
                            src={sidebarIcons[index]?.url}
                            alt="icon"
                          />
                        </div>
                        {el?.name}
                      </label>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* selected city */}
          <div className="become-a-seller">
            {city && (
              <div className="address-btn-container">
                <button
                  className="city"
                  onClick={() => props.setShowModal(true)}
                >
                  <BsGeoAltFill size={22} color="#009f7f" />
                  {city}
                </button>
                <span>{city}</span>
              </div>
            )}

            {/* Custom Cart Dropdown - Replaced Bootstrap Dropdown */}
            <div
              className="cart-page-dropdown"
              style={{ position: "relative", display: "inline-block" }}
            >
              <button
                type="button"
                onClick={() => setBucketDropdownOpen(!bucketDropdownOpen)}
                className="header-basket-btn"
              >
                <CImage src="/images/bucket-icon.svg" />
                {bucketCount > 0 && (
                  <span
                    className="pulse"
                    style={{
                      position: "absolute",
                      top: "2px",
                      right: "2px",
                      background: "#ff4444",
                      color: "white",
                      borderRadius: "50%",
                      width: "16px",
                      height: "16px",
                      lineHeight: "16px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "10px",
                      fontWeight: "bold",
                      padding: "8px",
                    }}
                  >
                    {bucketCount}
                  </span>
                )}
              </button>

              {/* Custom Cart Dropdown Menu */}
              {bucketDropdownOpen && (
                <>
                  {/* Backdrop to close dropdown when clicking outside */}
                  {/* Dropdown Content */}
                  <div
                    className="cart-dropdown-main-wrapper"
                    style={{
                      position: "absolute",
                      top: "100%",
                      right: "0",
                      minWidth: "540px",
                      maxHeight: "540px",
                      overflowY: "auto",
                      backgroundColor: "white",
                      boxShadow: "0px 7px 48px 0px #00000040",
                      zIndex: 999,
                      borderRadius: "20px",
                      padding: "18px 26px",
                      overflowX: "hidden",
                    }}
                    onClick={(e) => e.stopPropagation()}
                    tabIndex={0}
                    role="button"
                    onKeyDown={(e) => e.preventDefault()}
                  >
                    <div
                      className="ezy-heading-value d-f a-c j-sb"
                      style={{ marginBottom: "15px" }}
                    >
                      <h2>Basket Items</h2>
                      <Button
                        className="close-bucket-button"
                        type="button"
                        onClick={() => setBucketDropdownOpen(false)}
                      >
                        ×
                      </Button>
                    </div>
                    {bucketLoading ? (
                      <div
                        style={{
                          padding: "20px",
                          textAlign: "center",
                          color: "#000000",
                          fontSize: "18px",
                        }}
                      >
                        Loading bucket items...
                      </div>
                    ) : bucketItems && bucketItems.length > 0 ? (
                      <>
                        {/* Cart Items */}

                        <div
                          style={{
                            maxHeight: "300px",
                            overflowY: "auto",
                            overflowX: "hidden",
                          }}
                        >
                          {bucketItems.map((item, index) => {
                            const itemKey = `${item.productID}-${item.productVariationID}`;
                            const isUpdating = updatingItems[itemKey];

                            return (
                              <div
                                key={item.bucketItemID || index}
                                style={{
                                  padding: "0px",
                                  border: "none",
                                }}
                              >
                                <article
                                  className="cart-dropdown-content"
                                  style={{
                                    display: "flex",
                                  }}
                                >
                                  <div className="ezy-buy-start">
                                    <img
                                      className="img-full"
                                      alt="product-image-cart"
                                      src={
                                        item?.productRes?.imageUrl ||
                                        "/images/product-image.png"
                                      }
                                      onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src =
                                          "/images/product-image.png";
                                      }}
                                      style={{
                                        width: "92px",
                                        height: "100px",
                                        objectFit: "contain",
                                      }}
                                    />
                                  </div>

                                  <div
                                    className="ezy-inner-content"
                                    style={{ flex: 1 }}
                                  >
                                    <div className="ezy-heading-value">
                                      <h2 className="cart-title">
                                        {item?.productRes?.name ||
                                          "Product Name"}
                                      </h2>
                                      <Button
                                        className="remove-bucket-item-button"
                                        type="button"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleRemoveItem(item);
                                        }}
                                        disabled={isUpdating}
                                      >
                                        <BsFillTrashFill size={17} />
                                      </Button>
                                    </div>

                                    {item.productRes?.category
                                      ?.categoryName && (
                                      <p
                                        className="product-category"
                                        style={{
                                          fontSize: "14px",
                                          margin: "2px 0",
                                        }}
                                      >
                                        <span>Category</span>:{" "}
                                        {
                                          item.productRes?.category
                                            ?.categoryName
                                        }
                                      </p>
                                    )}

                                    {item.productRes?.productBrand
                                      ?.brandName && (
                                      <p
                                        className="product-category"
                                        style={{
                                          fontSize: "14px",
                                          margin: "2px 0",
                                        }}
                                      >
                                        <span>Brand</span>:{" "}
                                        {
                                          item.productRes?.productBrand
                                            ?.brandName
                                        }
                                      </p>
                                    )}

                                    {Array.isArray(
                                      item.productRes?.productVariations,
                                    ) &&
                                      item.productRes.productVariations.length >
                                        0 && (
                                        <div
                                          style={{
                                            marginTop: "6px",
                                            display: "flex",
                                            flexWrap: "wrap",
                                            gap: "5px",
                                          }}
                                        >
                                          {item.productRes.productVariations
                                            .filter(
                                              (variation) =>
                                                variation.productVariationName,
                                            )
                                            .map((variation) => (
                                              <span
                                                key={
                                                  variation.productVariationID
                                                }
                                                style={{
                                                  backgroundColor: "#D8B90B",
                                                  color: "#000",
                                                  padding: "2px 6px",
                                                  borderRadius: "4px",
                                                  fontSize: "14px",
                                                  display: "inline-block",
                                                  fontWeight: "600",
                                                }}
                                              >
                                                {variation.productVariationName}
                                              </span>
                                            ))}
                                        </div>
                                      )}

                                    {/* Display quantity without controls */}
                                    <div
                                      style={{
                                        marginTop: "8px",
                                        fontSize: "14px",
                                        fontWeight: "500",
                                        color: "#333",
                                      }}
                                    >
                                      {/* Quantity: {item.quantity || 1} */}
                                      {isUpdating && (
                                        <span
                                          style={{
                                            marginLeft: "10px",
                                            fontSize: "12px",
                                            color: "#666",
                                          }}
                                        >
                                          Updating...
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </article>
                              </div>
                            );
                          })}
                        </div>

                        {/* Footer with View Full Bucket button */}
                        <div className="cart-action-buttons d-f j-sb w-100 mt-10">
                          <button
                            type="button"
                            onClick={() => clearAllBucket()}
                            className="fs-16 lh-14 fw-600 clr-grey br-grey-1 border-radius-4 p-inline-20 p-block-12 bg-transparent"
                          >
                            Clear All
                          </button>
                          <Button
                            onClick={clickSearchAll}
                            className="buy-now-btn fw-600 p-inline-30"
                          >
                            Search All ({bucketCount})
                          </Button>
                        </div>
                      </>
                    ) : (
                      <div
                        style={{
                          padding: "20px",
                          textAlign: "center",
                          color: "#666",
                        }}
                      >
                        Your basket is empty
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>

            <Button
              className="btn bg-green br-green text-white header-become-seller"
              style={{ fontWeight: "600" }}
              onClick={() =>
                window.open(
                  "https://in.ezybuy.app/vendorRegistration",
                  "_blank",
                )
              }
            >
              Get Listed Free
            </Button>
          </div>
        </div>
      </Row>
    </Container>
  );
};

export default Header;
